import { createSpotlightTourDebugSection } from 'features/app_shell/debug_tools/createSpotlightTourDebugSection'
import { registerDebugPanelSection } from 'features/app_shell/debug_tools/debugRegistry'
import { SPOTLIGHT_TOUR_DEBUG_IDS } from 'features/app_shell/debug_tools/spotlightTourDebugConfig'

registerDebugPanelSection({
  id: 'scheduling-page-tour',
  title: 'Scheduling page tour',
  removeBy: '2026-12-01',
  order: 30,
  Component: createSpotlightTourDebugSection(SPOTLIGHT_TOUR_DEBUG_IDS.SCHEDULING_PAGE),
})
